import React, { useState } from 'react';
import { usePaymentIntent } from '../contexts/PaymentIntentProvider';
import { submitFeedback } from '../utils/ratingHelpers';

const FeedbackForm = () => {
    const [ feedback, setFeedback ] = useState('');
    const [ submitting, setSubmitting ] = useState(false);
    const [ error, setError ] = useState('');

    const { rating, setRating, setFeedbackComplete } = usePaymentIntent();

    const handleSubmit = async () => {
        if (submitting) return;

        const text = feedback.trim();

        // Feedback is optional — an empty submit completes the feedback step
        if (!text) {
            setFeedbackComplete(true);
            return;
        }

        setSubmitting(true);
        setError('');

        try {
            const updated = await submitFeedback(rating.id, text);
            setRating(updated);
            setFeedbackComplete(true);
        } catch (err) {
            console.error('Error submitting feedback:', err);
            setError('Something went wrong sending your feedback. Please try again.');
            setSubmitting(false);
        }
    }

    const handleSkip = () => {
        if (submitting) return;
        setFeedbackComplete(true);
    }

    return(
        <div className="payment-container">
            <p className="thank-you-title">Thank you for choosing The Perfect Clean</p>
            <div className="feedback-panel">
                <p className="feedback-title">
                    We're sorry your service didn't meet your expectations. We are going to have one of our team members call you right away.
                </p>
                <p className="feedback-subtitle">Please let us know what we could have done better.</p>
                <textarea
                    className="feedback-textarea"
                    rows="4"
                    maxLength="2000"
                    value={feedback}
                    onChange={(e) => setFeedback(e.target.value)}
                    disabled={submitting}
                />
            </div>
            {error && <p className="error-message">{error}</p>}
            <button className="tip-submit-btn" onClick={handleSubmit} disabled={submitting}>
                {submitting ? 'Loading...' : 'Submit feedback'}
            </button>
            <button className="feedback-skip" onClick={handleSkip} disabled={submitting}>Skip</button>
        </div>
    )
}

export default FeedbackForm;
